document.addEventListener('DOMContentLoaded', () => {
  const WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbzkZSt0PhtPlHZBeYL5nqwXH-4s78TdlvSlza6uCaJ8nSAWJ533PHtpLpUjvf3HsIOa/exec'; 
  // Replace with your deployed Web App URL

  const fields = [
    'checkout_token','contact_email','contact_marketing_opt_in','delivery_first_name','delivery_last_name',
    'delivery_address1','delivery_address2','delivery_city','delivery_zone','delivery_postal_code',
    'delivery_phone','delivery_save_shipping_information','payment_basic',
    'payment_billing_address_selector','summary_reductions'
  ];

  // ✅ Only proceed if checkout_token exists
  const checkoutToken = sessionStorage.getItem('checkout_token');
  if (!checkoutToken) {
    console.log('No checkout_token found — skipping sheet save.');
    return;
  }

  // Build payload from sessionStorage
  const payload = {};
  fields.forEach(k => {
    const val = sessionStorage.getItem(k);
    payload[k] = val === null ? '' : val;
  });

  // Convert to form-encoded (avoids CORS preflight)
  const formData = new URLSearchParams();
  for (const [key, value] of Object.entries(payload)) {
    formData.append(key, value);
  }

  fetch(WEB_APP_URL, {
    method: 'POST',
    body: formData
  })
  .then(res => res.text())
  .then(txt => {
    try {
      const resp = JSON.parse(txt);
      if (resp.status === 'ok') {
        console.log('Saved to sheet');
      } else {
        console.error('Sheet error', resp);
      }
    } catch (e) {
      console.error('Response parse error:', txt);
    }
  })
  .catch(err => {
    console.error('Network error:', err);
  });
});
